<div *ngIf="patient" fxLayout="column">
  <div *ngIf="(isCreateMode$ | async) === false else createEl" fxLayout="column">
    <mat-form-field>
      <mat-label>{{ 'patient-account.form.select-label' | translate }}</mat-label>
      <mat-select [formControl]="formControl" [compareWith]="compareAccounts" [required]="required">
        <mat-option [value]="null">{{ 'patient-account.form.no-account' | translate }}</mat-option>
        <mat-option *ngFor="let account of patientAccounts$ | async" [value]="account">
          EID: {{ account.eid }}
          <ng-container *ngIf="account.clearanceStatus">
            - Clearance Status: {{ 'statuses.account-clearance.' + account.clearanceStatus | translate }}
          </ng-container>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div class="text-center mb-5">
      <button mat-stroked-button color="primary" (click)="createNewPatientAccount()">
        {{ 'patient-account.form.create-new' | translate }}
      </button>
    </div>
  </div>

  <ng-template #createEl>
    <div>
      <form [formGroup]="accountForm" fxLayout="column">
        <mat-form-field>
          <mat-label>{{ 'patient-account.form.eid' | translate}}</mat-label>
          <input matInput formControlName="eid" [required]="required" (blur)="onTouched()" />
        </mat-form-field>

        <mat-form-field>
          <mat-label>{{ 'patient-account.form.insurances' | translate}}</mat-label>
          <mat-select formControlName="insurances" multiple [required]="required">
            <mat-option *ngFor="let insurance of insurances$ | async" [value]="insurance">
              {{ insurance.clinicCarrierName }}
              <ng-container *ngIf="insurance.memberId">
                - {{ insurance.memberId }}
              </ng-container>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </form>
      <div class="text-center mb-5">
        <button mat-stroked-button (click)="isCreateMode$.next(false)" color="primary">
          {{ 'common.cancel' | translate }}
        </button>
      </div>
    </div>
  </ng-template>
</div>
